import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["type", "name", "id", "value", "disabled"]

import type { OptionType } from '~src/admin/types';

// Props with default values

export default /*@__PURE__*/_defineComponent({
  __name: 'Checkboxes',
  props: /*@__PURE__*/_mergeModels({
    options: {},
    name: {},
    selection: { default: 'multiple' },
    type: { default: 'icon' },
    size: { default: 'default' },
    align: { default: 'horizontal' },
    globalDisabled: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



// Generate id
const generateID = (name: string, index: number) => {
    return `${name}-${index}`;
};

// Values
const values = _useModel<string[] | string>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`checkbox-wrapper type-${_ctx.type} align-${_ctx.align}`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`checkbox-item size-${_ctx.size}`),
        key: i
      }, [
        (option.label.length || option.value.length)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: generateID(_ctx.name, Number(i))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.selection === 'single' ? 'radio' : 'checkbox',
                name: _ctx.name,
                id: generateID(_ctx.name, Number(i)),
                value: option.value,
                disabled: option?.disabled || _ctx.globalDisabled,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values).value = $event))
              }, null, 8, _hoisted_2), [
                [_vModelDynamic, values.value]
              ]),
              _createTextVNode(" " + _toDisplayString(option.label), 1)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ], 2))
}
}

})